import { Injectable } from '@angular/core';
import { SvcDataTableSettings } from './svc-data-table-settings.model';

@Injectable({
  providedIn: 'root',
})
export class SvcDataTableCustomSettings extends SvcDataTableSettings {}
